const _excluded = ["horizontal", "options", "renderContent", "defaultValue", "value", "onChange", "show", "placement", "container", "menuStyle", "overlayRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/alloy-react-button';
import { pickKeys } from '@adsk/alloy-react-helpers';
import Overlay from '@adsk/alloy-react-overlay';
import { stylePropType } from '@adsk/alloy-react-theme';
import ActionButtonControl from './Control';
import { menuItemShape, menuCategoryShape } from '../../helpers/propTypes';
import useMenuButton from '../../hooks/useMenuButton';
import Menu from '../../Menu';
/**
 * Button component with Menu
 */
const ActionButtonWrapped = (_ref, ref) => {
  let {
      horizontal = true,
      options = [],
      renderContent = p => /*#__PURE__*/React.createElement(Menu, p),
      defaultValue = [],
      value,
      onChange,
      show: showProp,
      placement: placementProp = Overlay.PLACEMENTS.BOTTOM_START,
      container = document.body,
      menuStyle = {
        width: 200
      },
      overlayRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    getControlProps,
    getMenuProps
  } = useMenuButton({
    defaultValue,
    value,
    onChange
  });
  return /*#__PURE__*/React.createElement(Overlay, {
    show: showProp,
    target: ref,
    overlayRef: overlayRef,
    placement: placementProp,
    container: container,
    renderTarget: buttonProps => /*#__PURE__*/React.createElement(ActionButtonControl, _extends({
      horizontal: horizontal
    }, getControlProps({
      show: buttonProps.show
    }), buttonProps, props)),
    renderOverlay: _ref2 => {
      let {
        overlayProps,
        placement,
        handleHide
      } = _ref2;
      return renderContent(_objectSpread({
        'data-testid': 'ActionButton__Menu',
        ref: overlayProps.ref,
        placement,
        options,
        defaultValue,
        onClose: handleHide,
        style: [menuStyle, overlayProps.style]
      }, getMenuProps()));
    }
  });
};
const ActionButton = /*#__PURE__*/React.forwardRef(ActionButtonWrapped);
ActionButton.displayName = 'ActionButton';
ActionButton.propTypes = _objectSpread(_objectSpread({}, pickKeys(Overlay.propTypes, ['container', 'placement', 'show', 'overlayRef'])), {}, {
  /** Options for the action */
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  options: PropTypes.arrayOf(PropTypes.oneOfType([menuItemShape, menuCategoryShape])).isRequired,
  /** Disable button with horizontal or vertical dots*/
  horizontal: PropTypes.bool,
  /** Disable button functionality */
  disabled: PropTypes.bool,
  /** handle onClick event for button */
  onClick: PropTypes.func,
  /** render custom menu content, called with args ({ ref, placement, options, defaultValue, value, onChange, onClose, style }) */
  renderContent: PropTypes.func,
  /** Styles applied to the overlay element */
  menuStyle: stylePropType
});
export default Object.assign(ActionButton, {
  VARIANTS: Button.VARIANTS,
  SIZES: Button.SIZES,
  PLACEMENTS: Overlay.PLACEMENTS
});
//# sourceMappingURL=ActionButton.js.map